import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import {
  Container
} from 'semantic-ui-react';
import NavBar from '../../components/NavBar';
import HIMSBookingsList from '../../components/HIMSBookingsList';

class HIMSBookingSync extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    })
  }
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }
  handleOnLoading = (loading) => {
    this.setState({ loading });
  }

  render() {
    return (
      <Container>
        <NavBar
          header="HIMS Booking sync"
        />
        <HIMSBookingsList
          onLoading={this.handleOnLoading}
        />
      </Container>
    );
  }
}

export default withRouter(HIMSBookingSync);



// WEBPACK FOOTER //
// ./src/containers/Bookings/HIMSBookingSync.jsx